module.exports = __webpack_public_path__ + "static/media/category.e9dacbfb.svg";